import React from 'react';
import {Navigate} from 'react-router-dom';
import * as consts from '../../utils/constants';
import {getQueryParam} from '../../utils/helpers';

function NavigateLoginFeature() {
  const backUrlQuery = getQueryParam('back_url');
  const path = [window.location.pathname, window.location.search]
    .filter(part => !!part)
    .join('');
  const query = path ? `?back_url=${encodeURIComponent(path)}` : '';
  const to = `${consts.SLUG_LOGIN}${
    backUrlQuery !== consts.SLUG_LOGIN ? query : ''
  }`;
  return <Navigate to={to} />;
}

export default NavigateLoginFeature;
